import { useRef } from "react";

import { Accordion, styled } from "@parspec/pixel";

interface AccOptions {
    summary: React.ReactNode;
    details: React.ReactNode;
    labelId: string;
    rightSummary?: React.ReactNode;
}
interface ProductOrOptionTableContentProps {
    labelId?: string;
    name?: string;
    children?: JSX.Element;
    bomId: string
    tabCta?: React.ReactNode;
    options?: AccOptions[],
}


const StyledAccordion = styled(Accordion)({
    '&.MuiPaper-root': {
        margin: '0px !important'
    },
    '& .MuiAccordionSummary-content': {
        margin: '12px 0 !important',
    },
    '& .MuiAccordionDetails-root': {
        paddingBottom: '0px !important'
    }
})


const ProductOrOptionTableContent = ({ bomId, options }: ProductOrOptionTableContentProps) => {
    const sectionRef = useRef(null);

    return (
        <>
            {options && <StyledAccordion
                ref={sectionRef}
                expanded={true}
                options={options || []}
                sx={{ boxShadow: 'none' }}
                summaryStyle={{ position: 'sticky', top: '0px', zIndex: 3 }}
            />}
        </>
    )
}
export default ProductOrOptionTableContent;